import { LEGAL_FLYING_AFFILIATE_TERMS_EN } from './affiliate-terms.md';
import { LEGAL_FLYING_CANCELLATION_POLICY_EN } from './cancellation-policy.md';
import { LEGAL_FLYING_COOKIES_USAGE_EN } from './cookies-usage.md';
import { LEGAL_FLYING_IMPRINT_EN } from './imprint.md';
import { LEGAL_FLYING_PRIVACY_POLICY_EN } from './privacy-policy.md';
import { LEGAL_FLYING_TERMS_OF_USE_EN } from './terms-of-use.md';


export const LEGAL_FLYING_PAGES = [
	{ slug: 'cookies-usage', title: 'Cookies Usage', content: LEGAL_FLYING_COOKIES_USAGE_EN },
	{ slug: 'privacy-policy', title: 'Privacy Policy', content: LEGAL_FLYING_PRIVACY_POLICY_EN },
	{ slug: 'cancellation-policy', title: 'Cancellation Policy', content: LEGAL_FLYING_CANCELLATION_POLICY_EN },
	{ slug: 'terms-of-use', title: 'Terms of Use', content: LEGAL_FLYING_TERMS_OF_USE_EN },
	{ slug: 'affiliate-terms', title: 'Affiliate Terms', content: LEGAL_FLYING_AFFILIATE_TERMS_EN },
	{ slug: 'imprint', title: 'Imprint / Legal Notice', content: LEGAL_FLYING_IMPRINT_EN }
] as const;

export const LEGAL_FLYING_PAGE_CONTENT = {
	'cookies-usage': LEGAL_FLYING_COOKIES_USAGE_EN,
	'privacy-policy': LEGAL_FLYING_PRIVACY_POLICY_EN,
	'cancellation-policy': LEGAL_FLYING_CANCELLATION_POLICY_EN,
	'terms-of-use': LEGAL_FLYING_TERMS_OF_USE_EN,
	'affiliate-terms': LEGAL_FLYING_AFFILIATE_TERMS_EN,
	imprint: LEGAL_FLYING_IMPRINT_EN
} as const;
